import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-background grid place-items-center px-5">
      <div className="text-center max-w-md" data-testid="payment-cancel">
        <XCircle size={52} className="text-muted-foreground mx-auto mb-5" strokeWidth={1.5} />
        <h1 className="font-serif text-3xl mb-3">Checkout cancelled</h1>
        <p className="text-muted-foreground mb-8">No charge was made. You can pick a plan whenever you're ready.</p>
        <Link to="/products/health-memberships"><Button className="rounded-full bg-primary text-primary-foreground font-semibold">Back to memberships</Button></Link>
      </div>
    </div>
  );
}
